import { render, staticRenderFns } from "./ProductCategoryTranslationNewPopup.vue?vue&type=template&id=7c695ac2&"
import script from "./ProductCategoryTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports